import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'sd-whatsapp-widgets',
  templateUrl: './whatsapp-widgets.component.html',
  styleUrls: ['./whatsapp-widgets.component.scss']
})
export class WhatsappWidgetsComponent implements OnInit {
  whatsappVerificationForm: UntypedFormGroup;
  flagImageUrl = "https://songdewnetwork.com/sgmedia/country/";
  countries: any;
  selectedflag: string;
  placeholder: any = "+91";
  sent: Boolean = false;
  formSubmit=false;
  dropdownOpen = false;
  constructor(public api: ApiService, public user: UserService) {
    this.whatsappVerificationForm = new UntypedFormGroup({
      countrycode: new UntypedFormControl('+91'),
      mobileNumber: new UntypedFormControl(this.user.mobile, [
        Validators.required, Validators.minLength(5),
      ]),
      // agreeTerms: new FormControl(false, Validators.requiredTrue)
    })

  }

  ngOnInit(): void {
    this.getCountries()
  }
toggleDropdown() {
  this.dropdownOpen = !this.dropdownOpen;
}
  whatsappApi() {
    if (this.whatsappVerificationForm.valid) {
      this.formSubmit = false
      let num = this.placeholder + this.whatsappVerificationForm.controls.mobileNumber.value
      this.api.whatsappPost(num).subscribe((res: any) => {
        this.sent = res.success;
      })
    }else{
      this.formSubmit = true
    }

  }


  get mobileNumber() { return this.whatsappVerificationForm.get('mobileNumber') };

  getCountries() {
    this.api.getOppCountries().subscribe((res) => {
      this.countries = res;
    });
  }

  changeSelectedCountryCode(value: string, code): void {

    this.selectedflag = value;
    this.placeholder = '+' + code;
  }



}
